<mat-accordion class="property-search-accordion">
  @if (propertySearchOptions?.autoAddress !== false) {
    <mat-expansion-panel class="find-by-address" [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title> Find by Address </mat-panel-title>
      </mat-expansion-panel-header>
      <app-google-autocomplete
        (addressSelected)="onAddressSelected($event)"
        class="d-block"
        [address]="
          (searchPropertyQuery?.searchMode == 'autoAddress' && (searchPropertyQuery?.searchData?.address ?? '')) || ''
        "
      />
    </mat-expansion-panel>
  }
  @if (propertySearchOptions?.address !== false) {
    <mat-expansion-panel [expanded]="searchPropertyQuery?.searchMode == 'address'">
      <mat-expansion-panel-header>
        <mat-panel-title> Search by Address </mat-panel-title>
      </mat-expansion-panel-header>
      <form [formGroup]="searchByAddressForm">
        <div class="row">
          <div class="col-12 col-lg-6 mb-3">
            <profet-input
              formControlName="streetNumber"
              [label]="companyState.getPropertyFieldConfig().StreetNumber.fieldDisplayName"
            />
          </div>
          <div class="col-12 col-lg-6 mb-3">
            <profet-input
              formControlName="streetName"
              [label]="companyState.getPropertyFieldConfig().StreetName.fieldDisplayName"
            />
          </div>
          <div class="col-12 col-lg-6 mb-3">
            <profet-input
              formControlName="unitNumber"
              [label]="companyState.getPropertyFieldConfig().UnitNumber.fieldDisplayName"
            />
          </div>
          <div class="col-12 col-lg-6 mb-3">
            <profet-input
              formControlName="city"
              [label]="companyState.getPropertyFieldConfig().propertyCity.fieldDisplayName"
            />
          </div>
          <div class="col-12 col-lg-6 mb-3">
            <profet-select
              [label]="companyState.getPropertyFieldConfig().StateOrProvince.fieldDisplayName"
              formControlName="state"
              [options]="companyState.getEnumConfig(orderState.reportType).state"
              [showEmpty]="true"
            />
          </div>
          <div class="col-12 col-lg-6 mb-3">
            <profet-input
              formControlName="zip"
              [label]="companyState.getPropertyFieldConfig().propertyZip.fieldDisplayName"
              type="numberString"
            />
          </div>
          <div class="col-12 col-lg-6">
            <profet-input formControlName="fipsCode" type="numberString" label="County(FIPS) Code" />
          </div>
          <div class="col-12">
            <button
              (click)="initiateSearch(searchByAddressForm, 'address')"
              mat-flat-button
              class="small_btn float-end"
              color="primary"
              [disabled]="searchByAddressFormDisable"
            >
              Search
            </button>
          </div>
        </div>
      </form>
    </mat-expansion-panel>
  }
  @if (propertySearchOptions?.mls !== false) {
    <mat-expansion-panel [expanded]="searchPropertyQuery?.searchMode == 'mls'">
      <mat-expansion-panel-header>
        <mat-panel-title> Search by MLS Number </mat-panel-title>
      </mat-expansion-panel-header>
      <form [formGroup]="searchByMlsForm">
        <div class="row">
          <div class="col-12 col-lg-6 mb-3">
            <profet-input formControlName="mlsNumber" label="MLS #" />
          </div>
          <div class="col-12 col-lg-6">
            <profet-select
              [label]="companyState.getPropertyFieldConfig().StateOrProvince.fieldDisplayName"
              formControlName="state"
              [options]="companyState.getEnumConfig(orderState.reportType).state"
              [showEmpty]="true"
            />
          </div>
          <div class="col-12 mb-3">
            <profet-select
              formControlName="mlsBoard"
              [label]="companyState.getPropertyFieldConfig().MlsBoard.fieldDisplayName"
              [options]="mlsBoardList"
              [showEmpty]="true"
              [inProgress]="isMLSInProgress"
            />
          </div>

          <div class="col-12">
            <button
              (click)="initiateSearch(searchByMlsForm, 'mls')"
              mat-flat-button
              class="small_btn float-end"
              color="primary"
              [disabled]="searchByMlsForm.invalid"
            >
              Search
            </button>
          </div>
        </div>
      </form>
    </mat-expansion-panel>
  }
  @if (propertySearchOptions?.parcel !== false) {
    <mat-expansion-panel [expanded]="searchPropertyQuery?.searchMode == 'parcel'">
      <mat-expansion-panel-header>
        <mat-panel-title> Search by Parcel Number </mat-panel-title>
      </mat-expansion-panel-header>
      <form [formGroup]="searchByParcelForm">
        <div class="row">
          <div class="col-12 col-lg-6 mb-3">
            <profet-input
              formControlName="parcelNumber"
              [label]="companyState.getPropertyFieldConfig().ParcelNumber.fieldDisplayName"
              type="text"
            />
          </div>
          <div class="col-12 col-lg-6 mb-3">
            <profet-select
              [label]="companyState.getPropertyFieldConfig().StateOrProvince.fieldDisplayName"
              formControlName="state"
              [options]="companyState.getEnumConfig(orderState.reportType).state"
              [showEmpty]="true"
            />
          </div>
          <div class="col-12 mb-3">
            <profet-input formControlName="zip" label="ZIP" type="numberString" />
          </div>
          <div class="col-12">
            <button
              (click)="initiateSearch(searchByParcelForm, 'parcel')"
              mat-flat-button
              class="small_btn float-end"
              color="primary"
              [disabled]="searchByParcelForm.invalid"
            >
              Search
            </button>
          </div>
        </div>
      </form>
    </mat-expansion-panel>
  }
  @if (propertySearchOptions?.owner !== false) {
    <mat-expansion-panel [expanded]="searchPropertyQuery?.searchMode == 'owner'">
      <mat-expansion-panel-header>
        <mat-panel-title> Search by Owner </mat-panel-title>
      </mat-expansion-panel-header>
      <form [formGroup]="searchByOwnerForm">
        <div class="row">
          <div class="col-12 col-md-8 mb-3">
            <profet-input formControlName="ownerName" label="Owner Name" [required]="true" />
          </div>
          <div class="col-12 col-md-4 mb-3">
            <profet-input type="numberString" formControlName="zip" label="ZIP" [required]="true" />
          </div>
          <div class="col-12">
            <button
              (click)="initiateSearch(searchByOwnerForm, 'owner')"
              mat-flat-button
              class="small_btn float-end"
              color="primary"
              [disabled]="searchByOwnerForm.invalid"
            >
              Search
            </button>
          </div>
        </div>
      </form>
    </mat-expansion-panel>
  }
</mat-accordion>
